import { Box } from "@chakra-ui/react";
import type ConnectedService from "../../domain/ConnectedService";
import ConnectedServiceStatus from "./ConnectedServiceStatus";

interface ConnectedServicesProps {
  connectedServices: ConnectedService[];
}

const ConnectedServices = ({ connectedServices }: ConnectedServicesProps) => {
  return (
    <Box color="primary.100">
      {connectedServices.map((connectedService) => (
        <ConnectedServiceStatus
          key={connectedService.serviceName}
          connectedService={connectedService}
        />
      ))}
    </Box>
  );
};

export default ConnectedServices;
